export const MarkdownTarget = {
    TERMS: "MarkdownTarget.TERMS",
    PRIVACY: "MarkdownTarget.PRIVACY",
    IMPRESS: "MarkdownTarget.IMPRESS"
};
